import * as React from 'react';

import { TextileHelper } from '../../../ts/helpers/TextileHelper';
import {
  ContentSpaceDefinitions
} from '../../../ts/models/ContentDefinitions';
import { isSpaceType } from '../../../ts/models/ContentType';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { ExploreContentApi_ContentType } from '../../../ts/ServerApi/types/IContent';
import { SiteUrlsProps } from '../../selectors/SiteUrlsSelectors';
import { ServiceLocator } from '../../ServiceLocator';
import { ActionsMenu } from '../ActionsMenu/ActionsMenu';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface ContentCardProps extends SiteUrlsProps {
  readonly content: IContentInfo;
  readonly selected: boolean;
  readonly hoveredOrSelected?: boolean;
  readonly addContentFavorite: (contentId: string, contentType: ExploreContentApi_ContentType) => any;
  readonly removeContentFavorite: (contentId: string, contentIdForFavoriting: string, contentType: ExploreContentApi_ContentType, contentName: string) => any;
  readonly getContentDetail: (content: IContentInfo) => void;
  readonly inWorkbookDatasourcesSubspace: boolean;
  readonly inDatasourceConnectionsSubspace: boolean;
  readonly showActionMenu: boolean;
  readonly showAsRecommendation: boolean;
}

export abstract class ContentCard extends React.PureComponent<ContentCardProps> {

  private sanitize: ng.sanitize.ISanitizeService;

    constructor(props: ContentCardProps) {
      super(props);
      this.sanitize = ServiceLocator.get('$sanitize');
    }

    protected getDescription() {
      return TextileHelper.getPlainTextFromTextile(this.props.content.description, this.sanitize);
    }

    protected renderActionsMenu(): JSX.Element {
      return this.props.showActionMenu &&
        <ActionsMenu
          targetItems={[ this.props.content ]}
          disabled={ this.props.selected }
          useIcon={true}/>;
    }

    protected handleShowTooltip = () => {
      this.props.getContentDetail(this.props.content);
    }
}

export function getContentUrlForItem(content: IContentInfo, urls: SpacesSiteUrls): string | undefined {
  const contentType = content.contentType;

  if (isSpaceType(contentType)) {
    const contentDefinition = ContentSpaceDefinitions[contentType];
    return contentDefinition.contentSpaceUrl(urls, content.id);
  }
}
